import {BRANCH_KEY_ACTION,} from "../../../actionType";


export default function (state = {}, action) {
    switch (action.type) {
        case BRANCH_KEY_ACTION:
            return {
                ...state,
                branchKey:action.branchKey,
            };
        default:
            return state;
    }
}
